import { memo } from 'react';

// Components
import Anchor from '@Components/Utils/Anchor';

// Utilities
import classnames from 'classnames';

// Styles
import styles from './Breadcrumb.module.scss';

// Icons
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface PathLevelProps {
    path?: string;
    label: string;
}

interface BreadcrumbProps {
    rootTitle?: string;
    className?: string;
    itemClassName?: string;
    colorClassName?: boolean
    paths?: Array<PathLevelProps>;
}

const Breadcrumb: React.FC<BreadcrumbProps> = memo((props) => {
    const className = classnames([styles.breadcrumb, props.className]);

    return props.paths ? (
        <div className={className}>
            <div className={styles.route_item}>
                <Anchor href="/" className={classnames([styles.route_name, { [styles.color]: props.colorClassName }])}>
                    <span>{props.rootTitle}</span>
                </Anchor>
            </div>
            {props.paths.map(
                (level: PathLevelProps, index) =>
                    level && (
                        <div key={`route-item-${index}`} className={classnames([styles.route_item, props.itemClassName])}>
                            <FontAwesomeIcon className={styles.icon} width={16} height={16} icon={faAngleRight} />
                            {level?.path ? (
                                <Anchor href={level?.path} className={classnames([styles.route_name, { [styles.color]: props.colorClassName }])}>
                                    <span className={classnames({ [styles.color]: props.colorClassName })}>{level?.label}</span>
                                </Anchor>
                            ) : (
                                <span className={classnames([styles.route_name, { [styles.color]: props.colorClassName }])}>{level?.label}</span>
                            )}
                        </div>
                    ),
            )}
        </div>
    ) : null;
});

Breadcrumb.defaultProps = {
    className: '',
    rootTitle: 'Trang chủ',
    colorClassName: false
};

export default Breadcrumb;
